/**
 * Web entry — fonts (self-hosted, zero CDN), styles, i18n, error telemetry.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/cairo';
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import './styles/index.css';
import { initI18n, type Locale } from './i18n';
import { api } from './lib/api';
import App from './App';

// Everything is logged — including the frontend (spec: observability).
window.addEventListener('error', (e) => {
  void api.telemetry([{ level: 'error', message: e.message, stack: e.error?.stack, url: location.href }]);
});
window.addEventListener('unhandledrejection', (e) => {
  void api.telemetry([{ level: 'error', message: `unhandledrejection: ${String(e.reason)}`, url: location.href }]);
});

const storedLocale = ((): Locale => {
  try {
    const prefs = JSON.parse(localStorage.getItem('vidply-prefs') ?? '{}') as { state?: { locale?: string } };
    return prefs.state?.locale === 'ar' ? 'ar' : 'en';
  } catch {
    return 'en';
  }
})();

await initI18n(storedLocale);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
